/** Shared viewport breakpoints for Pulse responsive layout. */
export const BREAKPOINTS = {
  mobileMax: 430,
  tabletMin: 768,
  tabletMax: 1024,
  desktopMin: 1025,
  designWidth: 1728,
  zoomMax: 1727,
} as const;

export function isFluidLayout(width = window.innerWidth): boolean {
  return width <= BREAKPOINTS.tabletMax;
}
